/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable';
import { empty, of, timer } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, expand, filter, map, reduce, switchMap, take, throttleTime } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { getFacilities, throttledGetFacilities } from '.';
import { AppAction, AppState } from '..';
import config from '../../config';
import { Facility } from '../../db/stores/facilities';
import { FIVE_MINUTES } from "../../utils/time";
import { getCommonHeaders } from '../../utils/epics';
import { PagedResponse } from '../../utils/types';
import { fetchTokenActions } from '../session';

const throttledGetFacilitiesEpic = (action$: ActionsObservable<AppAction>, state$: StateObservable<AppState>) => {
  return action$.pipe(
    filter(isActionOf([throttledGetFacilities, fetchTokenActions.success])),
    throttleTime(FIVE_MINUTES),
    map(getFacilities.request)
  )
}

const getFacilitiesEpic = (action$: ActionsObservable<AppAction>, state$: StateObservable<AppState>) => {
  return action$.pipe(
    filter(isActionOf(getFacilities.request)),
    switchMap(() => timer(0, 8.64e7)),
    switchMap(() => {
      const headers = getCommonHeaders(state$);
      return ajax.get(`${config.dfdmHost}/api/facilities?max=1500&eval_client=true`, headers).pipe(
        expand((resp) => {
          const response: PagedResponse<Facility> = resp.response;
          if (!response || !response.next) {
            return empty();
          }
          return ajax.get(response.next, headers);
        }),
        take(3), // HACK: Instead of downloading 43000 facilities, just take 3,000
        reduce((acc, res) => ([...acc, ...(res.response.results as Facility[])]), [] as Facility[]),
        map((facilities) => {
          return getFacilities.success(facilities);
        }),
        catchError((e) => of(getFacilities.failure(e)))
      );
    })
  );
};

// const storeFacilitiesEpic = (action$: ActionsObservable<AppAction>, state$: StateObservable<AppState>) => {
//   return action$.pipe(
//     filter(isActionOf(getFacilities.success)),
//     switchMap((a) => {
//       const facilities: Facility[] = a.payload;
//       return from(
//         getDB()
//           .then((db) => {
//             const store = db.transaction(FACILITIES_STORE, 'readwrite').objectStore(FACILITIES_STORE);
//             return Promise.all(facilities.filter((f) => f.farm).map((f) => store.put(f)));
//           })
//           .then(() => facilitiesDatabaseUpdated())
//           .catch((e) => facilitiesDatabaseUpdateError(e))
//       );
//     })
//   );
// };

export default combineEpics(
  getFacilitiesEpic,
  throttledGetFacilitiesEpic
  // storeFacilitiesEpic,
);
